<template>
  <div :class="$style.container">
    <p
      v-if="showSaveMore"
      :class="$style.saveMore"
      data-test-id="AnnualMonthlyToggle__saveMoreAnnualDefaultText"
    >
      (Save More)
    </p>
    <SegmentedButton
      :name="`billingOptionsButton__${name}`"
      :options="$options.billingOptions"
      :value="selectedBillingOption"
      @input="handleBillingOptionChanged"
    />
  </div>
</template>

<script>
import {
  SegmentedButton,
} from '@jumpcloud/ui-components';
import { mapActions, mapGetters } from 'vuex';

const billingOptions = [
  { label: 'Annual Billing', value: 'annual' },
  { label: 'Monthly Billing', value: 'monthly' },
];

const pricingModule = 'PricingModule';

export default {
  name: 'AnnualMonthlyToggle',

  billingOptions,

  components: {
    SegmentedButton,
  },

  props: {
    name: {
      required: true,
      type: String,
    },
    showSaveMore: Boolean,
    suggestedPlan: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapGetters(pricingModule, { isAnnual: 'getIsAnnual' }),

    billingType() {
      return this.isAnnual ? 'Annual Billing' : 'Monthly Billing';
    },

    selectedBillingOption() {
      return this.isAnnual
        ? this.$options.billingOptions[0].value
        : this.$options.billingOptions[1].value;
    },
  },

  methods: {
    ...mapActions(pricingModule, ['setIsAnnual']),

    handleBillingOptionChanged() {
      this.setIsAnnual(!this.isAnnual);
      this.$emit('change', this.billingType);
    },
  },
};
</script>

<style module>
.container {
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 40px 0;
}

.saveMore {
  color: teal;
  display: inline-block;
  font-weight: bold;
  margin-right: var(--jc-spacer);
}
</style>
